export default {
  baseStyle: { cursor: 'pointer' },
  variants: {
    normal: {
      textDecoration: 'underline',
      color: 'primary.fg',
      fontWeight: 600,
      _hover: {
        color: 'primary.emphasized',
      },
      _active: {
        color: 'primary.emphasized',
      },
    },
    basic: {
      textDecoration: 'none',
      _hover: {
        textDecoration: 'underline',
      },
    },
    unstyled: {
      textDecoration: 'none',
      _hover: {
        textDecoration: 'none',
      },
    },
    subtle: {
      textDecoration: 'underline',
      color: 'gray.fg', // Assuming 'dark' refers to a general dark foreground color
      fontWeight: 600,
      _hover: {
        color: 'gray.fg',
      },
      _active: {
        color: 'gray.fg',
      },
    },
    light: {
      textDecoration: 'underline',
      color: 'primary.muted',
      fontWeight: 600,
      _hover: {
        color: 'primary.emphasized',
      },
      _active: {
        color: 'primary.emphasized',
      },
    },
    white: {
      textDecoration: 'underline',
      color: 'primary.contrast',
      fontWeight: 600,
      _hover: {
        color: 'primary.subtle',
      },
      _active: {
        color: 'primary.muted',
      },
    },
    'subtle-gray': {
      fontSize: '14px',
      textDecoration: 'none',
      color: 'fg.muted',
      _hover: {
        color: 'gray.fg',
        textDecoration: 'underline',
      },
      _active: {
        color: 'gray.fg',
        textDecoration: 'underline',
      },
    },
  },
  defaultProps: {
    variant: 'normal',
  },
}
